import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-756e13f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tile-gradient" }, null, -1))
const _hoisted_2 = { class: "tile-content" }
const _hoisted_3 = { class: "tile-eyebrow" }
const _hoisted_4 = { class: "tile-title" }
const _hoisted_5 = { class: "tile-dates" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: `/trips/${_ctx.trip.year}`,
    class: "trip-tile"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "tile-image",
        style: _normalizeStyle(_ctx.image ? { backgroundImage: `url(${_ctx.image})` } : {})
      }, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.trip.year), 1),
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.trip.location), 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.formatDateRange(_ctx.trip.startDate, _ctx.trip.endDate)), 1)
        ])
      ], 4)
    ]),
    _: 1
  }, 8, ["to"]))
}